<template>
  <header class="page-hero">
    <div class="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
      <div class="min-w-0 text-left">
        <p class="text-[9px] font-bold uppercase tracking-wide text-blue-100/95">
          {{ eyebrow }}
        </p>
        <p class="mt-0.5 text-[15px] font-black leading-tight md:text-base">
          {{ title }}
        </p>
        <p
          v-if="description"
          class="mt-1 max-w-2xl text-[10px] font-semibold leading-4 text-white/90 md:text-[11px]"
        >
          {{ description }}
        </p>
      </div>
      <div v-if="$slots.actions" class="w-full min-w-0 sm:w-auto sm:shrink-0 [&>*]:w-full sm:[&>*]:w-auto">
        <slot name="actions" />
      </div>
    </div>
  </header>
</template>

<script lang="ts">
export default {
  props: {
    eyebrow: { type: String, default: "" },
    title: { type: String, default: "" },
    description: { type: String, default: "" },
  },
};
</script>
